import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import HybridComparisonSection from './components/HybridComparisonSection';
import FeaturesGrid from './components/FeaturesGrid';
import TrustedBySection from './components/TrustedBySection';
import AboutSnippet from './components/AboutSnippet';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Cultaz - Hybrid Retail Management Software | Cloud & Offline POS for Nigerian Retailers</title>
        <meta name="description" content="Own an online store in under 3 minutes or run a reliable offline POS. Cultaz is hybrid retail management software designed for Nigerian retailers. Cloud POS, desktop POS, inventory management, and analytics. Trusted by 5,000+ retailers." />
        <meta name="keywords" content="Cultaz, POS system Nigeria, offline POS, cloud POS, inventory management, retail software Nigeria, point of sale, online store builder, Nigerian retailers, business management software" />
        <meta name="author" content="Cultaz" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:title" content="Cultaz - Hybrid Retail Management Software | Cloud & Offline POS" />
        <meta property="og:description" content="Own an online store in under 3 minutes or run a reliable offline POS. Hybrid retail management software for Nigerian retailers. Trusted by 5,000+ businesses." />
        <meta property="og:image" content="https://cultaz.com/banners/1.png" />
        <meta property="og:url" content="https://cultaz.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Cultaz" />
        <meta property="og:locale" content="en_NG" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cultaz - Hybrid Retail Management Software | Cloud & Offline POS" />
        <meta name="twitter:description" content="Own an online store in under 3 minutes or run a reliable offline POS. Hybrid retail management software for Nigerian retailers." />
        <meta name="twitter:image" content="https://cultaz.com/banners/1.png" />
        <meta name="twitter:site" content="@cultaz" />
        <link rel="canonical" href="https://cultaz.com/" />
        <meta name="theme-color" content="#6366f1" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <HybridComparisonSection />
          <FeaturesGrid />
          <AboutSnippet />
          <TrustedBySection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Home;